import {useState} from 'react';

import {articleReactionMemoryRepository} from '../repositories/article-reactions-memory-repositiory';
import {useArticleModel} from '../utils/shared/useArticleModel';

const useArticleData = articleId => {
  const articleData = useArticleModel(articleId);
  const [allReactions, setAllReactions] = useState(articleReactionMemoryRepository.getAllReactions());

  articleReactionMemoryRepository.subscribe((_, value) => setAllReactions(value));

  return {
    commentsCount: articleData.commentsCount,
    reactionsCount: Object.values(allReactions.all[articleId]).reduce((acc, reaction) => acc + reaction.count, 0),
    ...articleData
  };
};

export {useArticleData};
